import PropTypes from "prop-types";

function ES({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 600 400"
      width="22"
      height="22"
      className={className}
    >
      <rect width="600" height="400" fill="#aa151b" />
      <rect y="100" width="600" height="200" fill="#f1bf00" />
      <g transform="translate(100, 100) scale(0.4)">
        {/* Shield */}
        <path
          d="M100 0 L200 0 L200 300 L100 300 Z"
          fill="#ffffff"
          stroke="#000000"
          strokeWidth="2"
        />
        {/* Crown */}
        <circle
          cx="150"
          cy="-30"
          r="30"
          fill="#f1bf00"
          stroke="#aa151b"
          strokeWidth="2"
        />
        {/* Pillars */}
        <rect
          x="80"
          y="50"
          width="20"
          height="200"
          fill="#ffffff"
          stroke="#000000"
          strokeWidth="2"
        />
        <rect
          x="200"
          y="50"
          width="20"
          height="200"
          fill="#ffffff"
          stroke="#000000"
          strokeWidth="2"
        />
        {/* Ribbon */}
        <path
          d="M80 250 C100 270, 200 270, 220 250"
          fill="none"
          stroke="#aa151b"
          strokeWidth="4"
        />
        {/* Additional emblem details can be added here */}
      </g>
    </svg>
  );
}

ES.propTypes = {
  className: PropTypes.string,
};

ES.defaultProps = {
  className: "",
};

export default ES;
